export default __webpack_public_path__ + "static/media/Spinner.0c299348.gif";